<template>
  <div class="runPointChart" ref="runPointChart"></div>
</template>

<script>
import {getRunPointSeries} from '../factoryData';

export default {
  name: 'runPoints',
  props: {
    chartData: {
      default: {}
    }
  },
  watch: {
    chartData(val) {
      this.getPointData(val);
    }
  },
  mounted() {
    this.getPointData(this.chartData);
  },
  beforeUnmount() {
    if (this.echartsOne) {
      this.echartsOne.dispose();
      this.echartsOne.dispose();
    }
  },
  methods:{
    getPointData(data) {
      this.$nextTick(()=>{
        if (!this.echartsOne) {
          this.echartsOne = echarts.init(this.$refs.runPointChart);
        }
        this.echartsOne.setOption(getRunPointSeries(data.value,data.color1,data.color2));
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.runPointChart {
  width: 160px;
  height: 160px;
}
</style>
